import { render, staticRenderFns } from "./SignalTokenPriceChange.vue?vue&type=template&id=73d5d89a&scoped=true&"
import script from "./SignalTokenPriceChange.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalTokenPriceChange.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d5d89a",
  null
  
)

export default component.exports